<template>
    <div>
        <StepHeader
            :subtitle="subtitle"
            :description="description"
        />
        <StepBtnGroup
            class="mt-4 step-group format"
            :fields="fields"
            :selectedValue="selectedFormat"
            :orientation="'column'"
            :layout="'full-width'"
            :fullWidthFormat="true"
            @select-value="selectFormat"
        />
        <StepSaveByDefaultCheckbox 
            :selectedOption="selectedFormat" 
            stepId="format"
            :label ="$t('habiteoStudio.saveFormatByDefault')"
        />
    </div>
</template>

<script>
    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepBtnGroup from '@/components/myHabiteoStudio/steps/components/StepBtnGroup';
    import { mapGetters } from 'vuex';
    import StepSaveByDefaultCheckbox from '@/components/myHabiteoStudio/steps/components/StepSaveByDefaultCheckbox';

    export default {
        name: 'StepFormat',
        components: {
            StepHeader,
            StepBtnGroup,
            StepSaveByDefaultCheckbox
        },
        props: {
            subtitle: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            forms: {
                type: Array,
                required: true
            },
            selectedFormat: {
                type: Number,
                required: false
            }
        },
        data() {
            return {
                storageKey: 'myHabiteo-studio-step-format'
            }
        },
        mounted() {
            const storageValue = this.isLocalstorageAvailable ? JSON.parse(localStorage.getItem(this.storageKey)) : null;
            const defaultValue = this.$props.forms[0].inputs[0].value || storageValue || this.$props.forms[0].inputs[0].fields[0].value;
            this.selectFormat(defaultValue);
        },
        computed: {
            ...mapGetters(['isLocalstorageAvailable']),
            fields() {
                return this.$props.forms[0].inputs[0].fields;
            }
        },
        methods: {
            selectFormat(format) {
                this.$props.forms[0].inputs[0].value = format;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepFormat.vue